/* eslint-disable react-hooks/exhaustive-deps */
import {CommunicationProvider} from "context/CommunicationContext"
import {ChatRoomProvider} from "context/ChatRoomContext"
import {Notes} from "sections/NewCommunication/parts/Notes/Notes"

type Props = {
    studentProfileId: number
}

const StudentNoteTabView = (props: Props) => {
    const {studentProfileId} = props
    return <Notes studentProfileId={studentProfileId} />
}

export function StudentNoteTab(props: Props) {
    return (
        <CommunicationProvider>
            <ChatRoomProvider>
                <StudentNoteTabView {...props} />
            </ChatRoomProvider>
        </CommunicationProvider>
    )
}
